import {Findings} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {usePullRequestBasePath} from '../stores/layout-selectors'
import {isFeatureEnabled} from '@github-ui/feature-flags'

export const FindingsEntrypoint = () => (
  <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
    <Suspense fallback={null}>
      <FindingsContent />
    </Suspense>
  </ErrorBoundary>
)

const FindingsContent = () => {
  const basePath = usePullRequestBasePath()
  const viewToggleEnabled = isFeatureEnabled('copilot_code_review_findings_pr_view')

  return <Findings pullRequestBasePath={basePath} viewToggleEnabled={viewToggleEnabled} variant="page" />
}
